import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useHierarchicalGroupsMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["hierarchical-groups-masterdata"],
    queryFn: () => experienceMasterDataApi.getHierarchicalGroups({ language_code: "en" }),
    select: ({ data }) => data,
  });
}
